import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ValidItem } from "../types/inspect";
import useCustomNavigate from "hooks/common/useCustomNavigate";
import type { FeatureCollection } from "geojson";

export const useInspect = () => {
  const { id, requestId, aoiId } = useParams();
  const [item, setItem] = useState<ValidItem | undefined>(undefined);
  const [items, setItems] = useState<ValidItem[]>([]);
  const [aois, setAois] = useState<FeatureCollection | undefined>(undefined);
  const { navigateToReplacePath } = useCustomNavigate();

  useEffect(() => {
    handleFetechList();
  }, []);

  useEffect(() => {
    if (items.length === 0 || typeof id === "undefined") return;
    getItem();
  }, [id, items]);

  const getItem = () => {
    const findItem = items.find((item) => item.id === Number(id));
    if (typeof findItem === "undefined") {
      navigateToReplacePath("/inspect");
      return;
    }
    setItem(findItem);
    handleFetchAois(findItem);
  };

  const handleFetchAois = async (item: ValidItem) => {
    try {
      const response = await axios.get<FeatureCollection>(
        `${process.env.REACT_APP_BASE_URL}/valid/aoi/${item.companyId}?parentAoiId=${item.eeAoiId}`
      );
      setAois(response.data);
    } catch (e) {}
  };

  const handleFetechList = async () => {
    try {
      const response = await axios.get<ValidItem[]>(
        `${process.env.REACT_APP_BASE_URL}/valid/list`
      );

      setItems(response.data);
    } catch (e) {}
  };

  return {
    item,
    aois,
    requestId,
    aoiId,
  };
};
